import React from 'react';
import PropTypes from 'prop-types';

import Toaster from '../../../Toaster/Toaster';
import SocketContext from '../../../SocketContext';

class LoginRegisterLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <SocketContext.Consumer>
        {
          socket => (
            <div className={'store'}>
              <Toaster />
              {this.props.children}
            </div>
          )
        }
      </SocketContext.Consumer>
    );
  }
};

export default LoginRegisterLayout;
